/**
 * Scrolls a section into view. Vertical offset for the fixed header comes from
 * each section's CSS scroll-margin-top rather than manual maths here, so the
 * two can never disagree.
 */
export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (!element) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  element.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
};

/** Offset applied to section tops so anchored content clears the fixed header. */
export const SECTION_SCROLL_MARGIN = { xs: '76px', md: '92px' };

export const HEADER_HEIGHT = { xs: 64, md: 80 };
